import { useEffect } from 'react';
import { useDrawerStore } from "@/stores/drawerStore";

declare global {
  interface Window {
    Cal?: any;
  }
}

export function GlobalDrawer() {
  const { isOpen, close } = useDrawerStore();

  // Initialize Cal.com popup on mount
  useEffect(() => {
    (function (C: any, A: string, L: string) {
      let p = function (a: any, ar: any) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement("script")).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api: any = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ["initNamespace", namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, "https://app.cal.com/embed/embed.js", "init");

    if (window.Cal) {
      window.Cal("init", "popup", { origin: "https://app.cal.com" });
      window.Cal.ns["popup"]("ui", {
        cssVarsPerTheme: {
          light: { "cal-brand": "#292929" },
          dark: { "cal-brand": "#fafafa" }
        },
        hideEventTypeDetails: false,
        layout: "month_view"
      });
    }
  }, []);

  // When drawer opens, trigger Cal.com popup and immediately close drawer
  useEffect(() => {
    if (isOpen && window.Cal) {
      window.Cal.ns["popup"]("modal", {
        calLink: "princeps/poly-digital-workforce",
        config: { layout: "month_view" }
      });
      window.PolyAnalytics?.trackCTA('book_call', 'cal.com/princeps/poly-digital-workforce');
      close();
    }
  }, [isOpen, close]);

  // No visual drawer needed - we just trigger the popup
  return null;
}
